<template>
    <AppLayout>
        <!-- Download the thingy -->
        <div class="container pt-5">
            <div class="row justify-content-center">
                <div class="col-md-4 text-center">
                    <div class="action-buttons" v-if="hasActiveCertificate">
                        <button class="btn btn-light btn-lg mb-2" @click="downloadPDF($event)">
                            <i class="bi bi-download me-2"></i>
                            Download PDF
                        </button>

                    </div>
                </div>
            </div>
        </div>

        <div class="certificate-container">
            <div v-if="hasActiveCertificate">
                <!-- Certificate Display -->
                <div class="certificate-wrapper">
                    <div class="certificate" id="certificate">
                        <!-- Certificate Header -->
                        <div class="certificate-header">
                            <h1 style="font-weight: 800; font-size: 50px">ICDGP</h1>
                            <h1 class="institute-name">Institute of Cybersecurity and <br>Data Governance Professionals</h1>
                            <div class="certificate-subtitle d-none">Professional Certification Program</div>
                        </div>



                        <!-- Certificate Body -->
                        <div class="certificate-body">
                            <div class="certificate-title d-none">
                                Certificate of Professional Achievement
                            </div>

                            <div class="certification-name">
                                {{ certificate?.certificate_type ? certificate.certificate_type.charAt(0).toUpperCase() + certificate.certificate_type.slice(1) + ' Certificate' : 'Professional Certificate' }}
                            </div>

                            <div class="certificate-text">
                                <p class="presentation-text">This is to certify that</p> <br>



                                <div class="recipient-name">{{ user?.first_name || 'User Name' }} {{ user?.last_name || '' }}</div>


                                <!-- <p class="accomplishment-text">
                                    has successfully completed the requirements for
                                </p> -->

                                <p class="completion-text" v-if="certificate.certificate_type === 'membership'">
                                    has been admitted on this date as a member of the association and is entitled to all rights and benefits in accordance with by laws.
                                </p>

                                <div v-if="certificate.certificate_type === 'membership'">
                                    <br><br><br><br>
                                </div>
                                <p class="completion-text" v-else>
                                    has successfully completed all requirements and criteria for ICDGP Councils
                                </p>

                                <div class="pt-4" v-if="certificate.certificate_type === 'training'">
                                    <h2 class="text-primary">{{ certificate.program }}</h2>
                                    <h5>Certification</h5>
                                </div>

                            </div>

                            <!-- Certificate Details -->
                            <div class="certificate-details">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="detail-item">
                                            <strong>Certificate Number:</strong><br>
                                            <span class="detail-value">{{ certificate?.certificate_number || 'ICDGP-2025-CERT-001947' }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="detail-item">
                                            <strong>Issue Date:</strong><br>
                                            <span class="detail-value">{{ formatDate(certificate?.issue_date) }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="detail-item">
                                            <strong>Valid Until:</strong><br>
                                            <span class="detail-value">{{ formatDate(certificate?.expiry_date) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Certificate Footer -->
                        <div class="certificate-footer">
                            <div class="row align-items-end">
                                <div class="col-md-4">
                                    <div class="signature-section">
                                        <div v-if="leftSignatory && leftSignatory.signature_data" class="signature-image">
                                            <img :src="leftSignatory.signature_data" alt="Signature" />
                                        </div>
                                        <div v-else class="signature-line"></div>

                                        <div v-if="leftSignatory && leftSignatory.signature_data" class="signature-line"></div>

                                        <div class="signature-title">{{ leftSignatory ? `${leftSignatory.title} ${leftSignatory.full_name}` : 'Signature Required' }}</div>
                                        <div class="signature-role">{{ leftSignatory ? leftSignatory.position : 'Position Not Assigned' }}</div>
                                        <div class="signature-org" v-if="leftSignatory && leftSignatory.organization">{{ leftSignatory.organization }}</div>
                                    </div>
                                </div>
                                <div class="col-md-4 text-center">
                                    <div class="certificate-seal">
                                        <div class="seal-outer">
                                            <div class="seal-inner">
                                                <i class="bi bi-patch-check-fill"></i>
                                                <div class="seal-text">VERIFIED</div>
                                                <div class="seal-year">{{ certificate?.issue_date ? new Date(certificate.issue_date).getFullYear() : '2025' }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 text-end">
                                    <div class="signature-section">
                                        <div v-if="rightSignatory && rightSignatory.signature_data" class="signature-image">
                                            <img :src="rightSignatory.signature_data" alt="Signature" />
                                        </div>
                                        <div v-else class="signature-line"></div>
                                        <div v-if="rightSignatory && rightSignatory.signature_data" class="signature-line"></div>
                                        <div class="signature-title">{{ rightSignatory ? `${rightSignatory.title} ${rightSignatory.full_name}` : 'Signature Required' }}</div>
                                        <div class="signature-role">{{ rightSignatory ? rightSignatory.position : 'Position Not Assigned' }}</div>
                                        <div class="signature-org" v-if="rightSignatory && rightSignatory.organization">{{ rightSignatory.organization }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Verification Footer -->
                            <div class="verification-footer">
                                <div class="verification-text">
                                    <small>
                                        <i class="bi bi-check-circle-fill text-success me-1"></i>
                                        This certificate can be verified online at:
                                        <a :href="verificationUrl" target="_blank" class="text-success fw-bold text-decoration-none">
                                            {{ verificationUrl }}
                                        </a>
                                    </small>
                                </div>
                            </div>
                        </div>

                        <!-- Certificate Border Decorations -->
                        <div class="certificate-border">
                            <div class="border-corner border-top-left"></div>
                            <div class="border-corner border-top-right"></div>
                            <div class="border-corner border-bottom-left"></div>
                            <div class="border-corner border-bottom-right"></div>
                        </div>
                    </div>
                </div>

                <!-- Certificate Information -->
                <div class="certificate-info mt-4 d-none">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-header">
                                    <h5 class="mb-0">
                                        <i class="bi bi-info-circle me-2"></i>
                                        Certificate Information
                                    </h5>
                                </div>
                                <div class="card-body">
                                    <div class="info-grid">
                                        <div class="info-item">
                                            <strong>Program Duration:</strong>
                                            <span>6 Months Intensive Training</span>
                                        </div>
                                        <div class="info-item">
                                            <strong>Training Hours:</strong>
                                            <span>240 Hours</span>
                                        </div>
                                        <div class="info-item">
                                            <strong>Assessment Score:</strong>
                                            <span class="text-success">92/100 (Distinction)</span>
                                        </div>
                                        <div class="info-item">
                                            <strong>Practical Projects:</strong>
                                            <span>5 Real-world Case Studies</span>
                                        </div>
                                        <div class="info-item">
                                            <strong>CPD Credits:</strong>
                                            <span>45 Credits Earned</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-header">
                                    <h5 class="mb-0">
                                        <i class="bi bi-check2-square me-2"></i>
                                        Core Competencies Achieved
                                    </h5>
                                </div>
                                <div class="card-body">
                                    <div class="competencies-list">
                                        <div class="competency-item">
                                            <i class="bi bi-check-circle-fill text-success me-2"></i>
                                            Risk Assessment & Management
                                        </div>
                                        <div class="competency-item">
                                            <i class="bi bi-check-circle-fill text-success me-2"></i>
                                            Security Framework Implementation
                                        </div>
                                        <div class="competency-item">
                                            <i class="bi bi-check-circle-fill text-success me-2"></i>
                                            Data Governance & Compliance
                                        </div>
                                        <div class="competency-item">
                                            <i class="bi bi-check-circle-fill text-success me-2"></i>
                                            Incident Response Planning
                                        </div>
                                        <div class="competency-item">
                                            <i class="bi bi-check-circle-fill text-success me-2"></i>
                                            Security Audit & Assessment
                                        </div>
                                        <div class="competency-item">
                                            <i class="bi bi-check-circle-fill text-success me-2"></i>
                                            Privacy & Data Protection
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- No Certificate Message -->
            <div v-else class="no-certificate-container">
                <div class="no-certificate-card">
                    <div class="no-certificate-icon">
                        <i class="bi bi-certificate"></i>
                    </div>
                    <h2 class="no-certificate-title">No Active Certificate</h2>
                    <p class="no-certificate-text">
                        You don't have an active professional certificate yet. Join our certification program to earn your ICDGP certification and showcase your expertise in cybersecurity and data governance.
                    </p>
                    <div class="no-certificate-actions">
                        <button class="btn btn-primary btn-lg" @click="goToMembership">
                            <i class="bi bi-star me-2"></i>
                            Subscribe to Certification Program
                        </button>

                    </div>
                </div>
            </div>
        </div>

        <!-- Membership Subscription Modal -->
        <div v-if="showMembershipModal" class="membership-modal-overlay" @click="closeMembershipModal">
            <div class="membership-modal" @click.stop>
                <div class="modal-header">
                    <h3 class="modal-title">Choose Your Membership Tier</h3>
                    <button type="button" class="btn-close" @click="closeMembershipModal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p class="modal-subtitle">Select the membership tier that best fits your professional needs and career goals.</p>

                    <div class="membership-tiers">
                        <!-- Student Tier -->
                        <div class="tier-card">
                            <div class="tier-header">
                                <h4 class="tier-name">Student</h4>
                                <div class="tier-price">
                                    <span class="price">R200</span>
                                    <span class="period">/year</span>
                                </div>
                            </div>
                            <div class="tier-features">
                                <div class="feature-item">
                                    <i class="bi bi-check-circle text-success me-2"></i>
                                    <span>Basic Course Access</span>
                                </div>
                                <div class="feature-item">
                                    <span class="fw-bold">20 CPD Hours/year</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bi bi-x-circle text-danger me-2"></i>
                                    <span>No Mentorship</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bi bi-check-circle text-success me-2"></i>
                                    <span>Job Board Access</span>
                                </div>
                            </div>
                            <button class="btn btn-primary w-100" @click="subscribeToTier('student')">
                                Subscribe to Student
                            </button>
                        </div>

                        <!-- Individual Tier -->
                        <div class="tier-card featured">
                            <div class="tier-badge">Most Popular</div>
                            <div class="tier-header">
                                <h4 class="tier-name">Individual</h4>
                                <div class="tier-price">
                                    <span class="price">R500</span>
                                    <span class="period">/year</span>
                                </div>
                            </div>
                            <div class="tier-features">
                                <div class="feature-item">
                                    <i class="bi bi-check-circle text-success me-2"></i>
                                    <span>Full Course Access</span>
                                </div>
                                <div class="feature-item">
                                    <span class="fw-bold">40 CPD Hours/year</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bi bi-check-circle text-success me-2"></i>
                                    <span>Group Mentorship Sessions</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bi bi-check-circle text-success me-2"></i>
                                    <span>Job Board Access</span>
                                </div>
                            </div>
                            <button class="btn btn-primary w-100" @click="subscribeToTier('individual')">
                                Subscribe to Individual
                            </button>
                        </div>

                        <!-- Corporate Tier -->
                        <div class="tier-card">
                            <div class="tier-header">
                                <h4 class="tier-name">Corporate</h4>
                                <div class="tier-price">
                                    <span class="price">R800</span>
                                    <span class="period">/year</span>
                                </div>
                            </div>
                            <div class="tier-features">
                                <div class="feature-item">
                                    <i class="bi bi-check-circle text-success me-2"></i>
                                    <span>Full + Premium Course Access</span>
                                </div>
                                <div class="feature-item">
                                    <span class="fw-bold">Unlimited CPD Hours</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bi bi-check-circle text-success me-2"></i>
                                    <span>1-on-1 & Group Mentorship</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bi bi-check-circle text-success me-2"></i>
                                    <span>Priority Job Board Listings</span>
                                </div>
                            </div>
                            <button class="btn btn-primary w-100" @click="subscribeToTier('corporate')">
                                Subscribe to Corporate
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<style scoped>
/* Certificate Header Banner */
.certificate-header-banner {
    background: linear-gradient(135deg, #1e9579 0%, #2dd4bf 100%);
    color: white;
    padding: 4rem 0;
    margin-bottom: 3rem;
    position: relative;
    overflow: hidden;
}

.certificate-header-banner::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
        radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
    pointer-events: none;
}

.banner-content {
    position: relative;
    z-index: 2;
}

.banner-title {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
    line-height: 1.2;
}

.banner-subtitle {
    font-size: 1.2rem;
    opacity: 0.9;
    margin-bottom: 2rem;
    line-height: 1.6;
}

.certificate-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
}

.stat-item {
    display: flex;
    align-items: center;
    font-size: 1rem;
    font-weight: 500;
}

.stat-item i {
    color: rgba(255, 255, 255, 0.8);
    font-size: 1.1rem;
}

.action-buttons {
    position: relative;
    z-index: 2;
}

.action-buttons .btn-light {
    background-color: rgba(255, 255, 255, 0.9);
    border-color: rgba(255, 255, 255, 0.9);
    color: #1e9579;
    font-weight: 600;
    backdrop-filter: blur(10px);
    width: 100%;
}

.action-buttons .btn-light:hover {
    background-color: white;
    border-color: white;
    color: #176f5e;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.action-buttons .btn-outline-light {
    border-color: rgba(255, 255, 255, 0.7);
    color: white;
    font-weight: 500;
    backdrop-filter: blur(10px);
}

.action-buttons .btn-outline-light:hover {
    background-color: rgba(255, 255, 255, 0.2);
    border-color: white;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Responsive Design for Banner */
@media (max-width: 768px) {
    .certificate-header-banner {
        padding: 3rem 0;
        text-align: center;
    }

    .banner-title {
        font-size: 2rem;
    }

    .banner-subtitle {
        font-size: 1.1rem;
    }

    .certificate-stats {
        justify-content: center;
        gap: 1.5rem;
    }

    .action-buttons .btn {
        margin-bottom: 0.5rem;
    }
}

/* Certificate Container */
.certificate-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem 2rem 2rem;
    background-color: #f8f9fa;
    min-height: 50vh;
}

/* Certificate Wrapper */
.certificate-wrapper {
    display: flex;
    justify-content: center;
    padding: 2rem 0;
}

/* Main Certificate Styling */
.certificate {
    width: 100%;
    max-width: 900px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border: 3px solid #2c3e50;
    border-radius: 15px;
    padding: 3rem;
    position: relative;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    font-family: 'Fira Sans', serif;
    overflow: hidden;
}

.certificate::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
        radial-gradient(circle at 20% 80%, rgba(30, 149, 121, 0.03) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(45, 212, 191, 0.03) 0%, transparent 50%);
    pointer-events: none;
}

/* Certificate Header */
.certificate-header {
    text-align: center;
    margin-bottom: 2.5rem;
    position: relative;
    z-index: 2;
}

#certificate_logo {
    width: 120px;
    margin-bottom: .8em;
}


.certificate-logo .logo-circle {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #1e9579 0%, #2dd4bf 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1rem;
    color: white;
    font-size: 2rem;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.institute-name {
    font-size: 2rem;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 0.5rem;
    letter-spacing: 1px;
}

.certificate-subtitle {
    font-size: 1.1rem;
    color: #7f8c8d;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 2px;
}

/* Certificate Body */
.certificate-body {
    text-align: center;
    margin-bottom: 2rem;
    position: relative;
    z-index: 2;
}

.certificate-title {
    font-size: 2.5rem;
    font-weight: 300;
    color: #2c3e50;
    margin-bottom: 2rem;
    letter-spacing: 1px;
    text-transform: uppercase;
}

.presentation-text {
    font-size: 1.2rem;
    color: #7f8c8d;
    margin-bottom: 1rem;
    font-style: italic;
}

.recipient-name {
    font-size: 3rem;
    font-weight: 700;
    color: #1e9579;
    margin: 1.5rem 0;
    text-decoration: underline;
    text-decoration-color: #2dd4bf;
    text-decoration-thickness: 3px;
    text-underline-offset: 8px;
}

.accomplishment-text {
    font-size: 1.2rem;
    color: #7f8c8d;
    margin: 1.5rem 0;
    font-style: italic;
}

.certification-name {
    font-size: 2rem;
    font-weight: 600;
    color: #e74c3c;
    margin: 1.5rem 0;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.completion-text {
    font-size: 1rem;
    color: #7f8c8d;
    line-height: 1.6;
    max-width: 700px;
    margin: 1.5rem auto;
}

/* Certificate Details */
.certificate-details {
    margin: 2rem 0;
    padding: 1.5rem;
    background: rgba(102, 126, 234, 0.05);
    border-radius: 10px;
    border: 1px solid rgba(102, 126, 234, 0.1);
}

.detail-item {
    text-align: center;
    padding: 0.5rem;
}

.detail-item strong {
    color: #2c3e50;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.detail-value {
    color: #1e9579;
    font-weight: 600;
    font-size: 1rem;
}

/* Certificate Footer */
.certificate-footer {
    margin-top: 3rem;
    position: relative;
    z-index: 2;
}

.signature-section {
    text-align: center;
}

.signature-line {
    width: 200px;
    height: 2px;
    background: #2c3e50;
    margin: 0 auto 0.5rem;
}

.signature-image {
    width: 200px;
    height: 60px;
    margin: 0 auto 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.signature-image img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.signature-title {
    font-weight: 600;
    color: #2c3e50;
    font-size: 1.1rem;
    margin-bottom: 0.25rem;
}

.signature-role {
    color: #7f8c8d;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.signature-org {
    color: #7f8c8d;
    font-size: 0.8rem;
    font-style: italic;
    margin-top: 0.25rem;
}

/* Certificate Seal */
.certificate-seal {
    margin: 2rem 0;
}

.seal-outer {
    width: 120px;
    height: 120px;
    border: 4px solid #e74c3c;
    border-radius: 50%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: radial-gradient(circle, #fff 0%, #f8f9fa 100%);
    box-shadow: 0 0 20px rgba(231, 76, 60, 0.3);
}

.seal-inner {
    text-align: center;
    color: #e74c3c;
}

.seal-inner i {
    font-size: 2.5rem;
    margin-bottom: 0.25rem;
}

.seal-text {
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.seal-year {
    font-size: 0.7rem;
    font-weight: 500;
}

/* Verification Footer */
.verification-footer {
    text-align: center;
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 2px solid #ecf0f1;
}

.verification-text {
    color: #7f8c8d;
    font-size: 0.9rem;
}

.verification-text strong {
    color: #27ae60;
    font-family: 'Courier New', monospace;
}

/* Certificate Border Decorations */
.certificate-border {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
}

.border-corner {
    position: absolute;
    width: 60px;
    height: 60px;
    border: 3px solid;
    border-image: linear-gradient(135deg, #1e9579, #2dd4bf) 1;
}

.border-top-left {
    top: 20px;
    left: 20px;
    border-right: none;
    border-bottom: none;
    border-top-left-radius: 15px;
}

.border-top-right {
    top: 20px;
    right: 20px;
    border-left: none;
    border-bottom: none;
    border-top-right-radius: 15px;
}

.border-bottom-left {
    bottom: 20px;
    left: 20px;
    border-right: none;
    border-top: none;
    border-bottom-left-radius: 15px;
}

.border-bottom-right {
    bottom: 20px;
    right: 20px;
    border-left: none;
    border-top: none;
    border-bottom-right-radius: 15px;
}

/* Certificate Info Cards */
.certificate-info .card {
    border: 1px solid #e9ecef;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.certificate-info .card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.certificate-info .card-header {
    background: linear-gradient(135deg, #1e9579, #2dd4bf);
    color: white;
    border-radius: 12px 12px 0 0 !important;
    border: none;
}

.info-grid {
    display: grid;
    gap: 1rem;
}

.info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0;
    border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
    border-bottom: none;
}

.info-item strong {
    color: #2c3e50;
    font-weight: 500;
}

.info-item span {
    color: #7f8c8d;
    font-weight: 500;
}

.competencies-list {
    display: grid;
    gap: 0.75rem;
}

.competency-item {
    display: flex;
    align-items: center;
    font-weight: 500;
    color: #2c3e50;
}

/* Responsive Design */
@media (max-width: 768px) {
    .certificate-container {
        padding: 1rem;
    }

    .certificate {
        padding: 2rem 1.5rem;
    }

    .institute-name {
        font-size: 1.5rem;
    }

    .certificate-title {
        font-size: 2rem;
    }

    .recipient-name {
        font-size: 2.5rem;
    }

    .certification-name {
        font-size: 1.5rem;
    }

    .signature-line {
        width: 150px;
    }

    .action-buttons {
        flex-direction: column;
        gap: 0.5rem;
    }

    .action-buttons .btn {
        width: 100%;
    }
}

/* Print Styles */
@media print {

    .certificate-actions,
    .certificate-info {
        display: none !important;
    }

    .certificate-container {
        background: white !important;
        padding: 0 !important;
    }

    .certificate {
        box-shadow: none !important;
        border: 2px solid #2c3e50 !important;
        max-width: 100% !important;
        margin: 0 !important;
    }
}

/* PDF Generation Styles */
@media screen and (max-width: 0) {
    .certificate {
        box-shadow: none !important;
        border: 2px solid #2c3e50 !important;
        background: white !important;
    }

    .certificate::before {
        display: none !important;
    }

    .certificate-border {
        display: none !important;
    }
}

/* No Certificate Styles */
.no-certificate-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    padding: 2rem 0;
}

.no-certificate-card {
    text-align: center;
    max-width: 600px;
    padding: 3rem 2rem;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border-radius: 24px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
}

.no-certificate-icon {
    font-size: 4rem;
    color: #1e9579;
    margin-bottom: 1.5rem;
    opacity: 0.7;
}

.no-certificate-title {
    font-size: 2rem;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 1rem;
}

.no-certificate-text {
    font-size: 1.1rem;
    color: #7f8c8d;
    line-height: 1.6;
    margin-bottom: 2rem;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
}

.no-certificate-actions {
    margin-top: 2rem;
}

.no-certificate-actions .btn-primary {
    background: linear-gradient(135deg, #1e9579 0%, #2dd4bf 100%);
    border: none;
    color: white;
    padding: 1rem 2rem;
    font-weight: 600;
    border-radius: 12px;
    transition: all 0.3s ease;
}

.no-certificate-actions .btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(30, 149, 121, 0.3);
}

/* Responsive Design for No Certificate */
@media (max-width: 768px) {
    .no-certificate-container {
        padding: 1rem;
        min-height: 300px;
    }

    .no-certificate-card {
        padding: 2rem 1.5rem;
    }

    .no-certificate-title {
        font-size: 1.8rem;
    }

    .no-certificate-text {
        font-size: 1rem;
    }

    .no-certificate-actions .btn-primary {
        width: 100%;
    }
}

/* Membership Modal Styles */
.membership-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    padding: 1rem;
}

.membership-modal {
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    max-width: 900px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
}

.modal-header {
    padding: 1.5rem 2rem;
    border-bottom: 1px solid #e9ecef;
    display: flex;
    justify-content: between;
    align-items: center;
}

.modal-title {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #2c3e50;
}

.btn-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: #6c757d;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 50%;
    transition: all 0.3s ease;
}

.btn-close:hover {
    background: #f8f9fa;
    color: #495057;
}

.modal-body {
    padding: 2rem;
}

.modal-subtitle {
    color: #6c757d;
    font-size: 1rem;
    margin-bottom: 2rem;
    text-align: center;
}

.membership-tiers {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.5rem;
}

.tier-card {
    border: 2px solid #e9ecef;
    border-radius: 12px;
    padding: 2rem 1.5rem;
    text-align: center;
    position: relative;
    transition: all 0.3s ease;
}

.tier-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.tier-card.featured {
    border-color: #1e9579;
    box-shadow: 0 4px 15px rgba(30, 149, 121, 0.2);
}

.tier-badge {
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    background: #1e9579;
    color: white;
    padding: 0.25rem 1rem;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
}

.tier-header {
    margin-bottom: 1.5rem;
}

.tier-name {
    font-size: 1.5rem;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 0.5rem;
}

.tier-price {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 0.25rem;
}

.price {
    font-size: 2rem;
    font-weight: 700;
    color: #1e9579;
}

.period {
    color: #6c757d;
    font-size: 1rem;
}

.tier-features {
    margin-bottom: 2rem;
    text-align: left;
}

.feature-item {
    display: flex;
    align-items: center;
    margin-bottom: 0.75rem;
    font-size: 0.9rem;
    color: #495057;
}

.feature-item i {
    flex-shrink: 0;
}

.tier-card .btn-primary {
    background: linear-gradient(135deg, #1e9579 0%, #2dd4bf 100%);
    border: none;
    padding: 0.75rem 1.5rem;
    font-weight: 600;
    border-radius: 8px;
    transition: all 0.3s ease;
}

.tier-card .btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(30, 149, 121, 0.3);
}

/* Responsive Design for Modal */
@media (max-width: 768px) {
    .membership-modal {
        margin: 1rem;
        max-height: calc(100vh - 2rem);
    }

    .modal-header {
        padding: 1rem 1.5rem;
    }

    .modal-body {
        padding: 1.5rem;
    }

    .membership-tiers {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .tier-card {
        padding: 1.5rem 1rem;
    }

    .modal-title {
        font-size: 1.25rem;
    }
}

/* Responsive Design */
@media (max-width: 576px) {
    .membership-modal-overlay {
        padding: 0.5rem;
    }

    .tier-card {
        padding: 1.25rem 1rem;
    }

    .tier-name {
        font-size: 1.25rem;
    }

    .price {
        font-size: 1.75rem;
    }
}
</style>

<script setup>
import AppLayout from '../Layouts/AppLayout.vue';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { router } from '@inertiajs/vue3';

const props = defineProps({
    user: Object,
    certificate: Object,
    leftSignatory: Object,
    rightSignatory: Object,
});

// Reactive state for modal
const showMembershipModal = ref(false);

// Handle escape key to close modal
const handleEscapeKey = (event) => {
    if (event.key === 'Escape' && showMembershipModal.value) {
        closeMembershipModal();
    }
};

onMounted(() => {
    document.addEventListener('keydown', handleEscapeKey);
});

onUnmounted(() => {
    document.removeEventListener('keydown', handleEscapeKey);
});

// Computed property to check if user has an active certificate
const hasActiveCertificate = computed(() => {
    return props.certificate && props.certificate.expiry_date;
});

// Computed property for verification URL
const verificationUrl = computed(() => {
    if (props.certificate?.certificate_number) {
        return `${window.location.origin}/verify/${props.certificate.certificate_number}`;
    }
    return '';
});

// Helper function to format dates
const formatDate = (dateString) => {
    if (!dateString) return 'Not Set';
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

// Function to download certificate as PDF
const downloadPDF = async (event) => {
    const certificateElement = document.getElementById('certificate');

    if (!certificateElement) {
        alert('Certificate element not found!');
        return;
    }

    // Show loading state
    const button = event.target.closest('button');
    const originalText = button.innerHTML;
    button.innerHTML = '<i class="bi bi-hourglass-split me-2"></i>Generating PDF...';
    button.disabled = true;

    try {
        // Create canvas from certificate element
        const canvas = await html2canvas(certificateElement, {
            scale: 1.8, // Reduced scale to fit on one page
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff',
            width: certificateElement.offsetWidth,
            height: certificateElement.offsetHeight,
            logging: false, // Disable logging for cleaner output,
        });

        // Create PDF (A4)
        const pdf = new jsPDF('p', 'mm', 'a4');

        // Calculate optimal dimensions to fit on a single page
        // A4 size: 210mm width × 297mm height
        const pageWidth = 210;
        const pageHeight = 297;

        // Add margins for better appearance (10mm on each side)
        const margin = 3;
        const availableWidth = pageWidth - (margin * 2);

        // Calculate height based on aspect ratio to fit width
        const imgWidth = availableWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        // Center the certificate on the page
        const xPosition = margin;
        const yPosition = (pageHeight - imgHeight) / 2;

        // Add the image to PDF - centered on the page
        pdf.addImage(
            canvas.toDataURL('image/png'),
            'PNG',
            xPosition,
            yPosition,
            imgWidth,
            imgHeight
        );

        // Generate filename
        const certificateNumber = props.certificate?.certificate_number || 'CERTIFICATE';
        const filename = `ICDGP_Certificate_${certificateNumber}.pdf`;

        // Download the PDF
        pdf.save(filename);

        // Show success message
        button.innerHTML = '<i class="bi bi-check-circle me-2"></i>Downloaded!';
        setTimeout(() => {
            button.innerHTML = originalText;
            button.disabled = false;
        }, 2000);

    } catch (error) {
        console.error('Error generating PDF:', error);
        alert('Error generating PDF. Please try again.');
        button.innerHTML = originalText;
        button.disabled = false;
    }
};

// Function to show membership modal
const goToMembership = () => {
    showMembershipModal.value = true;
};

// Function to close membership modal
const closeMembershipModal = () => {
    showMembershipModal.value = false;
};

// Function to handle subscription
const subscribeToTier = (tier) => {
    router.post('/membership/subscribe', { tier });
    closeMembershipModal();
};
</script>
